import {
  Edit,
  ListButton,
  NumberInput,
  required,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants";
import { ReferenceAutoCompleteInput } from "@/inputs/ReferenceAutoCompleteInput";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const CountryPricesEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <ReferenceAutoCompleteInput
        module={MODULE_NAMES.COUNTRIES}
        source="country"
        optionText="name"
        optionValue="code"
        validate={[required()]}
      />
      <NumberInput label="Cost" source="trialCost" validate={required()} />
    </SimpleForm>
  </Edit>
);
